// auto_submit_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    console.log("Auto Submit Controller Connected");
  }
  
  submit(event) {
    // Get the form
    const form = this.element;
    
    // Show a subtle loading indicator
    const submitBtn = form.querySelector('input[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.value = 'Saving...';
    }
    
    // Submit the form
    form.submit();
  }
}

